import React, { Component } from 'react'
import './languageselector.scss'

class LanguageSelector extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isOpen: false
		}
	}

	componentDidMount() {
		document.addEventListener('mousedown', this.handleClickOutside)
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClickOutside)
	}

	handleClickOutside = (event) => {
		if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
			if (this.state.isOpen && !this.state.disableClickClose) this.setState({ isOpen: false })
		}
	}

	toggle = () => {
		this.setState({ isOpen: !this.state.isOpen })
	}

	render() {
		let isOpenClass = this.state.isOpen ? 'open' : ''
		const itemsClasses = ['selector-items', isOpenClass].join(' ')

		return (
			<React.Fragment>
				<div className={[this.props.classes, 'vbui--language-selector'].join(' ')}>
					<div className="selector-display" onClick={this.toggle}>
						{this.props.label}
						<span className="icon-down"></span>
					</div>
					<div className={itemsClasses}>
						<ul className="list">
							{this.props.options.map(function (option, i) {
								return ''
								/*
								return (
									<li key={option.value + i + '_select'} className={option.value === auxProps.label? 'active' : ''} data-value={option.value} onClick={props.changeLocale(option.value)}>
										<span>{option.text}</span>
									</li>
								)
								*/
							})}
						</ul>
					</div>
				</div>
			</React.Fragment>
		)
	}
}

export default LanguageSelector
